import React from 'react';
import styles from './BottomSheetWithBtn.module.scss';

export const BottomSheetWithBtn = ({
  title,
  message,
  buttonTitle,
  imgSrc,
  handleClose,
  dark
}) => {

  const handleCloseFn = () => {
    handleClose();
  }

  return (
    <section className={`${styles.wrapper}`} style={{}}>
      <div className={`${styles.container} ${dark ? styles.dark_container : ''}`} onClick={(event) => event.stopPropagation()}>
        <div className={styles.dragHandle} />
        <div className={styles.cont}>
          <div className={styles.left}>
            <header className={`${dark ? styles.dark_header : ''}`}>{title}</header>
            <p className={`${dark ? styles.dark_paragraph : ''}`}>{message}</p>
          </div>
          {imgSrc && <div className={styles.right}>
            <img src={`${imgSrc}`} />
          </div>}
        </div>
        <button className={`${dark ? styles.dark_button : ''}`} style={{ border: 'none' }} onClick={handleCloseFn}><span>{buttonTitle}</span></button>
      </div>
    </section>
  )
};